import en from './locales/en.json';
import de from './locales/de.json';

export const controlSpendingLocales = {
  en: { controlSpending: en },
  de: { controlSpending: de },
};

export { default as ControlSpendings } from './ControlSpendings.vue';
